import { BlockType } from '@backmarket/http-api/src/api-specs-content'

export const fullWidthComponents: Readonly<BlockType[]> = [
  BlockType.Carousel,
  BlockType.Faq,
] as const
